import TextWithPicture from './text-with-picture';

export default TextWithPicture;
